import { render, staticRenderFns } from "./stao.vue?vue&type=template&id=6e714ee6&scoped=true&"
import script from "./stao.vue?vue&type=script&lang=js&"
export * from "./stao.vue?vue&type=script&lang=js&"
import style0 from "./stao.vue?vue&type=style&index=0&id=6e714ee6&scoped=true&sass=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e714ee6",
  null
  
)

export default component.exports